// =============================================================================
// CENTRAL LINK CONFIG
// Every outbound/external link on the site is defined here in ONE place.
// To change where a button points, edit it here — nothing else needs touching.
// =============================================================================

// --- Social profiles (footer) ---
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/bondcollective",
  facebook: "https://www.facebook.com/bondcollectiveofficial/",
  linkedin: "https://www.linkedin.com/company/bondcollective",
};

// --- Header "Book On-Demand" CTA (global header; Flexspace catalog) ---
export const BOOK_ON_DEMAND_URL =
  "https://partners.flexspace.ai/offerings/catalog/bond-collective/";

// --- "Book a Space" member portal ---
// TODO: replace with the new portal URL once provided.
export const BOOK_A_SPACE_URL = "https://portal.bondcollective.com/";

// --- Existing-member portal sign-in (footer) ---
export const MEMBER_LOGIN_URL =
  "https://bondcollective.yardikube.com/member/content/login#/appaccess/login";

// --- Base URL used to build per-location membership & meeting-room booking links ---
// (Option B: each location/room keeps its own specific destination built from this base + IDs)
export const BOOKING_BASE = "https://portal.bondcollective.com/kubecc/content/#/app";

// --- Per-location "Book a Tour" scheduler links ---
const TOUR_ROOT = "https://meetings.hubspot.com/bond-collective";
const tour = (slug) => `${TOUR_ROOT}-${slug}/tour-calendar-${slug}`;

// Maps each location id -> its tour scheduler.
// Gather 4100 uses the East Austin calendar (as on the live site).
export const TOUR_LINKS = {
  "vinegar-hill": tour("vinegar-hill"),
  "fidi-55": tour("55-broadway"),
  bushwick: tour("bushwick"),
  greenpoint: tour("greenpoint"),
  "fidi-60": tour("60-broad"),
  "center-city": tour("center-city"),
  "market-street": "https://info.bondcollective.com/meetings/market-street/bond-collective-tour-calendar-market-street",
  "gather-4100": tour("east-austin"),
  "east-austin": tour("east-austin"),
};

// Generic "Book a Tour" CTA (header / home / footer / non-location pages)
// keeps the on-site inquiry form.
export const TOUR_FALLBACK = "/book-a-tour";
